<template>
    <div
        v-if="images.some((image) => image.length)"
        class="carousel-container"
        :class="{ 'carousel-container--small': product.availabilityPeriod > 1 || product.status !== 1 }"
    >
        <div v-if="imagesOverviews.length > 1" class="service-detail__other-images d-none d-md-flex vertical-scrollbar">
            <div
                v-for="(image, imageId) in imagesOverviews"
                :key="imageId"
                :class="{ active: imageId === slide }"
                class="service-detail__other-images__image"
                @click.prevent="goToSlide(imageId)"
            >
                <img v-lazy-load :alt="$t('loading')" src="/nuxt-assets/images/lazy-load-error.svg" :data-src="image" @error="setAltImg" />
            </div>
        </div>

        <div
            :class="{
                'service-detail__big-image-gallery': images.length > 1,
                [`service-detail__big-image js-product-stats js-product-stats-${id}`]: true,
            }"
            :data-id="id"
        >
            <div class="badgePlaceLeft">
                <span v-if="product.isPremiumExclusive" class="visual-tag" :style="{ 'background-color': '#e6007e', color: '#fff' }">
                    {{ $t('product.productIsPremiumExclusive') }}
                </span>
                <LastItemsOnStock v-if="product.lastItemsOnStockMessage" :message="product.lastItemsOnStockMessage" />
                <span
                    v-for="(visualTag, index) in visualTags"
                    v-else
                    :key="index"
                    class="visual-tag visual-tag--with-image"
                    :style="{ 'background-color': visualTag.backgroundColor, color: visualTag.textColor }"
                >
                    <img :src="visualTag.image" :alt="visualTag.name" loading="lazy" />
                    {{ visualTag.name }}
                </span>
            </div>
            <div class="badgePlace">
                <BadgeSquare v-if="pricePerPiece" :price-per-piece="pricePerPiece" class="mb-0" />

                <div v-if="attributes.isRecommended" class="badge-wrapper">
                    <div class="badge-product badge-product--recommend mb-2 mb-md-3 m-auto">
                        <!-- v-b-tooltip.hover="{ title: $t('attributes.isRecommended'), variant: 'white', placement: 'top' }" -->
                        <i class="ico ico--product-recommend"></i>
                    </div>
                </div>

                <span v-for="(visualTag, index) in visualTagImages" :key="index" class="visual-tag-image">
                    <img :src="visualTag.image" :alt="visualTag.name" loading="lazy" />
                </span>
            </div>

            <Modal
                modal-class="modal-max modal-photo"
                modal-name="productDetail"
                size="lg"
                :render-to-initial-html="true"
                @shown="modalShow"
            >
                <Carousel ref="carouselModal" v-model="slide" :wrap-around="false">
                    <Slide v-for="image in images" :key="image">
                        <!--                    <div class="carousel__item">-->
                        <a :href="image" class="service-detail__main-link" @click.prevent="openModal()">
                            <img :src="image" :alt="name" class="rounded main-image" loading="lazy" height="790" @error="setAltImg" />
                        </a>
                        <!--                    </div>-->
                    </Slide>
                </Carousel>
                <a
                    ref="carouselPrev"
                    href="#"
                    role="button"
                    class="carousel-control-prev-icon"
                    :class="slide === 0 ? 'd-none' : ''"
                    @click.prevent="prevSlide"
                >
                    <span aria-hidden="true" class="carousel-control-prev-icon"></span>
                </a>
                <a
                    ref="carouselNext"
                    href="#"
                    role="button"
                    class="carousel-control-next-icon"
                    :class="slide + 1 === images.length ? 'd-none' : ''"
                    @click.prevent="nextSlide"
                >
                    <span aria-hidden="true" class="carousel-control-next-icon"></span>
                </a>
            </Modal>
            <Carousel v-if="imagesOverviews.length > 1" ref="carousel" v-model="slide" :wrap-around="false" class="slide">
                <Slide v-for="(imageOverview, index) in imagesOverviews" :key="imageOverview" class="slide">
                    <!--                    <div class="carousel__item">-->
                    <a :href="imageOverview" class="service-detail__main-link" @click.prevent="openModal()">
                        <img
                            :src="imageOverview"
                            :alt="name"
                            class="rounded main-image"
                            :loading="index != 0 ? 'lazy' : 'eager'"
                            height="375"
                            @error="setAltImg"
                        />
                    </a>
                    <!--                    </div>-->
                </Slide>
            </Carousel>
            <a v-else :href="imagesOverviews[0]" class="service-detail__main-link" @click.prevent="openModal()">
                <img :src="imagesOverviews[0]" :alt="name" class="rounded main-image" loading="eager" height="375" @error="setAltImg" />
            </a>

            <!--            <Carousel-->
            <!--                v-if="images.some(image => image.length)"-->
            <!--                id="carousel"-->
            <!--                v-model="slide"-->
            <!--                :indicators="images.length > 1 ? true : false"-->
            <!--                :interval="0"-->
            <!--                background="#ffffff"-->
            <!--                :no-wrap="true"-->
            <!--                :no-touch="false"-->
            <!--                @sliding-end="onSlideEnd"-->
            <!--                @sliding-start="onSlideStart"-->
            <!--                ref="carousel"-->
            <!--            >-->
            <a
                ref="carouselPrev"
                href="#"
                role="button"
                class="carousel-control-prev"
                :class="slide === 0 ? 'd-none' : ''"
                :aria-label="$t('slides.previous')"
                @click.prevent="prevSlide"
            >
                <span aria-hidden="true" class="carousel-control-prev-icon"></span>
            </a>
            <a
                ref="carouselNext"
                href="#"
                role="button"
                class="carousel-control-next"
                :class="slide + 1 === images.length ? 'd-none' : ''"
                :aria-label="$t('slides.next')"
                @click.prevent="nextSlide"
            >
                <span aria-hidden="true" class="carousel-control-next-icon"></span>
            </a>

            <!--&lt;!&ndash;                <div v-if="images.length === 1" class="service-detail__main-image">&ndash;&gt;-->
            <!--&lt;!&ndash;                    <a :href="images[0]" @click.prevent="openModal()" class="service-detail__main-link">&ndash;&gt;-->
            <!--&lt;!&ndash;                        <img :src="images[0]" :alt="name" class="rounded main-image" data-not-lazy @error="setAltImg" />&ndash;&gt;-->
            <!--&lt;!&ndash;                    </a>&ndash;&gt;-->
            <!--&lt;!&ndash;                </div>&ndash;&gt;-->
            <!--                <Slide v-for="image in images" :key="image" class="service-detail__main-image" ref="mainDetailImages">-->
            <!--&lt;!&ndash;                    <template #img>&ndash;&gt;-->
            <!--                        <a :href="image" @click.prevent="openModal()" class="service-detail__main-link">-->
            <!--                            <img :src="image" :alt="name" class="rounded main-image" data-not-lazy @error="setAltImg" />-->
            <!--                        </a>-->
            <!--&lt;!&ndash;                    </template>&ndash;&gt;-->
            <!--                </Slide>-->
            <!--            </Carousel>-->
            <div v-if="imagesOverviews.length > 1" class="carousel-indicators">
                <a
                    v-for="(image, key) in imagesOverviews"
                    :key="key"
                    href="#"
                    :data-id="key"
                    class="carousel-indicators__items js-slime-carousel-point"
                    :class="{ 'point--active': key === slide }"
                    :aria-label="$t('slides.next')"
                    @click="slide = key"
                >
                </a>
            </div>
        </div>
    </div>
    <div v-else class="carousel-container--empty">
        <img src="/nuxt-assets/images/lazy-load-error.svg" class="rounded" data-not-lazy :alt="$t('notImage')" />
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import { Carousel, Slide } from 'vue3-carousel'
import Modal from '~/components/Modal.vue'
import BadgeSquare from '~/components/elements/BadgeSquare.vue'
import 'vue3-carousel/dist/carousel.css'
import ProductVisualTag from '~/models/Product/ProductVisualTag'
import FullProduct from '~/models/Product/FullProduct'
import LastItemsOnStock from '~/components/ui/LastItemsOnStock.vue'

export default {
    components: {
        LastItemsOnStock,
        Carousel,
        Modal,
        Slide,
        BadgeSquare,
    },

    props: {
        attributes: {
            type: Object,
            required: true,
        },
        discountPercent: {
            type: Number,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        id: {
            type: Number,
            default: 0,
        },
        images: {
            type: Array as PropType<string[]>,
            required: true,
        },
        imagesOverviews: {
            type: Array as PropType<string[]>,
            required: true,
        },
        pricePerPiece: {
            type: Number,
            default: 0,
        },
        price: {
            type: Number,
            default: 0,
        },
        product: {
            type: Object as PropType<FullProduct>,
            required: true,
        },
    },
    data() {
        return {
            slide: 0,
            showScrollbarr: false,
        }
    },
    computed: {
        visualTags() {
            return this.product.visualTags.merged.filter(
                (visualTag: ProductVisualTag) => visualTag.showOnProductDetail && visualTag.sort <= 0 && !visualTag.showAsImageOnly
            )
        },
        visualTagImages() {
            return this.product.visualTags.merged.filter(
                (visualTag: ProductVisualTag) => visualTag.showOnProductDetail && visualTag.showAsImageOnly
            )
        },
    },
    methods: {
        setAltImg(event: any): void {
            event.target.src = '/nuxt-assets/images/lazy-load-error.svg'
        },

        openModal(): void {
            setTimeout(() => {
                useNuxtApp().$bus.$emit('showModal', 'productDetail')
                document.addEventListener('keydown', this.logKey)
            }, 0)
        },

        goToSlide(id: number): void {
            this.slide = id
        },

        prevSlide() {
            this.slide--

            if (this.slide < 0) {
                this.slide = 0
            }
        },

        nextSlide() {
            this.slide++

            if (this.slide >= this.images.length) {
                this.slide = this.images.length - 1
            }
        },

        logKey(e: KeyboardEvent): void | false {
            if (e.keyCode === 37) {
                const prev: HTMLElement | null = document.querySelector('.carousel-control-prev')
                prev?.click()

                return false
            }

            if (e.keyCode === 39) {
                const next: HTMLElement | null = document.querySelector('.carousel-control-next')
                next?.click()

                return false
            }
        },

        modalShow() {
            const { carouselModal } = this.$refs

            if (carouselModal) {
                carouselModal.$el.classList.add('ready')

                carouselModal.restartCarousel()
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.slide {
    //width: 100%!important;
    display: block;
}

.sr-only {
    display: none;
}

.carousel:not(.ready) {
    .carousel-item {
        display: block;
    }
    .carousel-item ~ .carousel-item {
        display: none;
    }
}

.carousel__viewport {
    width: 100%;

    .main-image {
        max-height: 65vh;
    }
}

.carousel-container {
    display: flex;
    justify-content: center;
    margin-bottom: 2em;
    width: 100%;
    height: 250px;
    max-height: 250px;

    @include screen-md {
        height: 350px;
        max-height: 350px;
    }

    @include screen-lg {
        height: 400px;
        max-height: 400px;
    }

    .carousel-item {
        height: 250px;

        @include screen-md {
            height: 350px;
        }

        @include screen-lg {
            height: 375px;
        }
    }

    .service-detail__main-link {
        display: flex;
        height: 100%;
        width: 100%;
        align-items: center;
        justify-content: center;
    }

    .main-image {
        max-height: 250px;

        @include screen-md {
            max-height: 350px;
        }

        @include screen-lg {
            max-height: 375px;
        }
    }

    &--small {
        height: 190px;
        max-height: 190px;

        .main-image {
            max-height: 160px;
        }
    }
}

.carousel-control-prev,
.carousel-control-next {
    @media (max-width: 768px) {
        display: none;
    }
}

.badgePlaceLeft {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 90;
    width: 50%;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: start;
    flex-wrap: wrap;
    gap: 6px;
}

.badgePlace {
    position: absolute;
    top: 0;
    right: 10px;
    z-index: 90;
    display: flex;
    align-items: end;
    flex-wrap: wrap;
    flex-direction: column;
    gap: 10px;

    .discount {
        position: static;
        width: 48px;
        height: 48px;
        font-size: 16px;
        margin-bottom: 10px;

        @include screen-lg {
            width: 60px;
            height: 60px;
        }
    }

    .badge-wrapper {
        position: static;
        text-align: center;
        width: 48px;
        height: 48px;

        @include screen-lg {
            width: 60px;
            height: 60px;
        }
    }

    .badge-product {
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px;
        width: 48px;
        height: 48px;
        line-height: 48px;

        @include screen-lg {
            width: 60px;
            height: 60px;
            line-height: 60px;
        }

        &--recommend {
            border: 1px solid $color-cta;
        }

        .ico {
            margin: 0;
        }
    }
}
</style>

<style lang="scss" scoped>
.body-product-detail .modal-photo {
    .carousel {
        z-index: 10;
    }
}

.service-detail__main .carousel-indicators {
    bottom: -30px;

    @include screen-lg {
        display: none;
    }

    li {
        width: 10px;
        height: 10px;
        border-radius: 10px;
        background-color: $color-grey-dark;
        margin: 0 2px;
    }
    li.active {
        background-color: $color-purple;
    }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
    display: block;
}

.carousel-item-next.carousel-item-left,
.active.carousel-item-left {
    display: block;
    transform: translateX(-100%);
}
.carousel-item.active + .carousel-item {
    transform: translateX(100%);
    display: block;
}
.carousel-item.active.carousel-item-left + .carousel-item {
    transform: translateX(0);
}

.carousel-container--empty {
    text-align: center;
    width: 100%;
    padding-bottom: 20px;

    @include screen-lg {
        padding-bottom: 0;
    }

    img {
        width: 100px;
        height: 100px;
        margin: 0 auto;
    }
}

.carousel-indicators {
    display: flex;
    bottom: 0;
    margin-bottom: 125px;

    &__items {
        width: 10px;
        height: 10px;
        border-radius: 50px;
        background-color: rgba(105, 105, 105, 0.3);
        margin: 0 2px;

        &.point--active {
            background-color: $color-purple;
        }
    }

    @media (max-width: 572px) {
        margin-bottom: 15px;
    }
}

.pharmacy-detail-page {
    .carousel-indicators {
        position: static;
    }

    .carousel-container {
        margin-bottom: 4em;
    }
}

.visual-tag {
    text-align: left;
    border-radius: 50px;
    padding: 7px 13px;
    align-items: center;
    white-space: nowrap;
    font-size: 13px;
    display: grid;
    gap: 6px;

    &--with-image {
        grid-template-columns: 30px auto;
    }

    img {
        max-height: 19px;
        margin: 0 auto;
    }

    @media (max-width: 768px) {
        padding: 5px 10px 5px;
        font-size: 12px;

        img {
            max-height: 15px;
        }
    }
}

.visual-tag-image {
    max-width: 60px;
    padding: 0;
}
</style>
